import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'era-edit-device-name-modal',
  templateUrl: './edit-device-name-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [ReactiveFormsModule, FaIconComponent, NgbTooltip],
})
export class EditDeviceNameModalComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly formBuilder = inject(UntypedFormBuilder);

  public renameForm?: UntypedFormGroup;
  public initialName: string | null | undefined;

  ngOnInit(): void {
    this.renameForm = this.createForm();
  }

  private createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      desiredName: [this.initialName ?? '', Validators.pattern(/^[a-zA-Z0-9\s-]{0,10}$/)],
    });
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  save(): void {
    const result = {
      newName: this.renameForm?.get('desiredName')?.value,
    } satisfies Result;
    this.activeModal.close(result);
  }
}

interface Result {
  newName: string;
}
